/* eslint-disable import/prefer-default-export */
import { api } from './api'

export const syncWithHubspot = async (listingId: string): Promise<[boolean, Error | undefined]> => {
  try {
    const response = await api.api.post(`/hubspot/sync/${listingId}`, {})

    if (!response.ok) {
      const errorMessage = (response.data as any)?.message || 'Synchronization failed'
      throw new Error(errorMessage)
    }

    return [true, undefined]
  } catch (error) {
    const err = error instanceof Error ? error : new Error('Failed to synchronize with HubSpot')
    return [false, err]
  }
}
